import { createApp } from 'vue';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/product-detail';
import ProductDetails from 'views/ProductDetails.vue';
import ContactFormModal from 'components/forms/ContactFormModal.vue';

require('styles/pages/product-detail.less');

const app = createApp({
  components: { ProductDetails }
});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);
app.component('contact-form-modal', ContactFormModal);

app.mount('#app');
